module.exports = __webpack_public_path__ + "img/bg.61116c9d.jpg";